import React from 'react';
import { TimePickerInput2 } from '@/components/TimePickerInput2';

type Props = {
    value: string;
    onChange: (val: string) => void;
    disabled: boolean;
    /** 하위 호환용 — 새 UI에서는 사용하지 않음 */
    placeholder?: React.ReactNode | string;
    compact?: boolean;
    /** 종료 시간용 — 24:00 입력/표시 허용 */
    allowDayEnd?: boolean;
};

export const TimeSelect = ({ value, onChange, disabled, compact, allowDayEnd }: Props) => {
    return (
        <TimePickerInput2
            value={value || undefined}
            onChange={onChange}
            disabled={disabled}
            compact={compact}
            allowDayEnd={allowDayEnd}
        />
    );
};
